import React from "react";
import MarketingHeader from "@/components/MarketingHeader";

// Illustrative placeholder examples — not real GovCo.AI customers. Swap in
// real logos/quotes as they come in.
const STORIES = [
  {
    company: "Meridian Federal Solutions",
    descriptor: "8(a)-certified IT services, 18 employees",
    stat: "4 days",
    statLabel: "avg. proposal turnaround, down from 3 weeks",
    quote: "We used to lose solicitations just because we couldn't turn a compliant draft around in time. Now our first draft is ready before the kickoff call even ends.",
    role: "VP of Business Development",
  },
  {
    company: "Ironclad Systems Group",
    descriptor: "DoD cybersecurity contractor, 60 employees",
    stat: "2 awards",
    statLabel: "won in their first quarter using GovCo.AI",
    quote: "The Compliance Matrix alone paid for the platform. We stopped losing points on requirements we technically met but never wrote down.",
    role: "Director of Capture",
  },
  {
    company: "Beacon Point Consulting",
    descriptor: "HUBZone professional services, 12 employees",
    stat: "3x",
    statLabel: "more solicitations responded to per month",
    quote: "As a small shop, we could only chase a handful of RFPs at once. AI shredding and drafting means our two-person team covers what used to take five.",
    role: "Founder & Principal",
  },
  {
    company: "Vertex Cloud Partners",
    descriptor: "FedRAMP-focused cloud migration, 34 employees",
    stat: "0 missed",
    statLabel: "P0 requirements on their last review",
    quote: "The pre-submission checklist catches what a tired reviewer at midnight won't. It's blocked us from submitting an incomplete package twice now.",
    role: "Proposal Manager",
  },
];

export default function SuccessStories() {
  return (
    <div className="mkt-page" data-testid="page-success-stories">
      <MarketingHeader />

      <section className="mkt-hero">
        <div className="mkt-eyebrow">◢ SUCCESS STORIES</div>
        <h1 className="mkt-h1">How contractors are using GovCo.AI to win more work</h1>
        <p className="mkt-sub">
          A look at the kind of results teams see once opportunity discovery, drafting, and compliance
          all live in one place.
        </p>
      </section>

      <section className="mkt-body">
        <div className="stories-grid">
          {STORIES.map((s) => (
            <div className="story-card" key={s.company}>
              <span className="pill-soon story-tag">Illustrative example</span>
              <div className="story-company">{s.company}</div>
              <div className="story-descriptor">{s.descriptor}</div>
              <div className="story-stat-row">
                <span className="story-stat">{s.stat}</span>
                <span className="story-stat-label">{s.statLabel}</span>
              </div>
              <p className="story-quote">“{s.quote}”</p>
              <div className="story-role">{s.role}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mkt-final-cta">
        <h2 className="mkt-h2">Write your own success story</h2>
        <p className="mkt-sub">No card, no commitment — just your next solicitation.</p>
        <a className="mkt-cta-btn" href="/#demo" data-testid="stories-cta">Schedule a demo →</a>
      </section>
    </div>
  );
}
